/* eslint-disable */
import React from "react";

export const Constants = {
  Keys: {
    forgetPass: "forgotpass",
    register: "register",
  },
};
